/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_Forbidden_TitleInputs */

const vi_smartlab_settings_forbidden_title = /** @type {(inputs: Smartlab_Settings_Forbidden_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không có quyền xem cấu hình SmartLab`)
};

/**

* @param {Smartlab_Settings_Forbidden_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_forbidden_title = /** @type {((inputs?: Smartlab_Settings_Forbidden_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_Forbidden_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_forbidden_title(inputs)
});